module.exports = __webpack_public_path__ + "static/media/thumbtack.737815c8.svg";